import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const FactoryIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M6.66542 4.7998L7.83835 11.7117H3L4.17293 4.7998H6.66542ZM9.4801 13.5V8.17529L15.2402 12.0002L15.2402 8.17529L21.0002 12.0003V19.5H3.00026L3 13.5H9.4801ZM17.0401 15.3562L17.0402 11.5313L19.2002 12.9657V17.7H4.80018L4.80008 15.3H11.2801V11.5313L17.0401 15.3562Z"
      />
    </SvgIcon>
  );
});
